export class ModelNamesFilter {
  iPad = false;
  AppleTV = false;
  iPhone = false;
  iPod = false;
}
